import React, { Component } from 'react';
import { Spin } from 'antd';

class Loading extends Component {

    render = () => {
        return (
            <Spin spinning={ true } tip="Loading..."/>
        )
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/commons/Loading.js